<div class="container">
	<div class="row">
		<div class="col-12">
			<a routerLink="/" class="app-logo logo" title="Specialized Auth"></a>
		</div>
	</div>
</div>
<div class="d-flex align-items-center form-centering" role="main">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-12 col-lg-6">
				<div class="container">
					<div class="row">
						<h1 class="col-12 z5-main-header">
							<span i18n="sign in form title|form title for the site authentication">Sign in to your account</span>
						</h1>
					</div>

					<form [formGroup]="formInputs">
						<div class="row">
							<div class="col-12 top-margin-20">
								<mat-form-field appearance="standard" class="width-100">
									<mat-label i18n>Email address</mat-label>
									<input
										matInput
										type="email"
										autocomplete="username"
										placeholder="jo@example.com"
										i18n-placeholder
										formControlName="email"
										(blur)="onEmailBlur()"
									/>
									<mat-error
										appFormErrorMessage
										[type]="formEditorInputType.email"
										[errorFormControl]="formInputs.controls.email"
									></mat-error>
								</mat-form-field>

								<mat-checkbox color="primary" class="form-checkbox" formControlName="rememberMe" i18n>Remember my email</mat-checkbox>

								<mat-form-field appearance="standard" class="width-100">
									<mat-label i18n>Password</mat-label>
									<input
										matInput
										[type]="hidePassword ? 'password' : 'text'"
										formControlName="password"
										autocomplete="current-password"
										[disabled]="disablePasswordAuth"
									/>
									<button
										mat-icon-button
										matSuffix
										(click)="hidePassword = !hidePassword"
										i18n-title="show/hide password button"
										title="Show/Hide password"
										[attr.aria-pressed]="hidePassword"
										type="button"
										tabindex="-1"
										[disabled]="disablePasswordAuth"
									>
										<mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
									</button>
									<mat-error
										appFormErrorMessage
										[type]="formEditorInputType.password"
										[errorFormControl]="formInputs.controls.password"
									></mat-error>
								</mat-form-field>
							</div>
						</div>

						<div class="row">
							<div class="col-md-6 top-margin-30 order-md-2">
								<button
									mat-flat-button
									type="submit"
									color="primary"
									class="width-100"
									(click)="onFormSubmit()"
									[disabled]="disablePasswordAuth"
								>
									<span i18n="sign in button|button title to submit the sign in form">Sign in</span>
								</button>
							</div>
							<div class="col-md-6 top-margin-30 order-md-1">
								<button mat-flat-button type="button" class="width-100" routerLink="/reset" [disabled]="disablePasswordAuth">
									<span i18n="reset password button|button title to navigate to the password reset screen"
										>Reset password</span
									>
								</button>
							</div>
							<div class="col-md-12 top-margin-30 order-md-3">
								<button 
									mat-flat-button
									type="button" 
									class="width-100"
                                    (click)="employeeSSO()"
								>
									<span>SBC SSO</span>
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="build-version">
	<app-build-version></app-build-version>
</div>
